import { DatePicker } from '@fluentui/react-datepicker-compat';
import { Dropdown, Field, Option } from '@fluentui/react-components';
import { dateOnlyToPickerDate, toApiDateOnly } from '../../utils/dateOnly';
import { todayUtc, type ParameterQuery } from './pricingParameterHelpers';
import { pricingItemLabel } from './tenantPricingOverrideHelpers';
import type { PricingParameterCatalog } from './usePricingParameterCatalog';

export interface PricingParameterScopeBarProps {
  catalog: PricingParameterCatalog;
  query: ParameterQuery;
  onChange: (query: ParameterQuery) => void;
  showDate?: boolean;
}

const barStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
  alignItems: 'start',
  gap: 16,
  maxWidth: 560,
} as const;

const controlStyle = { width: '100%', minWidth: 0 } as const;

const PricingParameterScopeBar = ({
  catalog,
  query,
  onChange,
  showDate = false,
}: PricingParameterScopeBarProps) => {
  const selectedItem = catalog.pricingItems.find(
    (item) => String(item.id) === query.pricingItemId
  );

  return (
    <div style={barStyle}>
      <Field label="Pricing item">
        <Dropdown
          style={controlStyle}
          value={selectedItem ? pricingItemLabel(selectedItem) : ''}
          selectedOptions={query.pricingItemId ? [query.pricingItemId] : []}
          placeholder="Select pricing item"
          onOptionSelect={(_, data) =>
            onChange({ ...query, pricingItemId: data.optionValue ?? '' })
          }
        >
          {catalog.pricingItems.map((item) => (
            <Option
              key={item.id}
              value={String(item.id)}
              text={pricingItemLabel(item)}
            >
              {pricingItemLabel(item)}
            </Option>
          ))}
        </Dropdown>
      </Field>
      {showDate && (
        <Field label="Effective on" hint="Dates are UTC.">
          <DatePicker
            style={controlStyle}
            value={dateOnlyToPickerDate(query.pricingDate)}
            onSelectDate={(selected) =>
              onChange({
                ...query,
                pricingDate: toApiDateOnly(selected) || todayUtc(),
              })
            }
          />
        </Field>
      )}
    </div>
  );
};

export default PricingParameterScopeBar;
